<template>
  <div class="overflow-auto" style="max-height: 30vh;">
    <ts-table
      :columns="columns"
      :records="resources"
      :loading="loading"
      :rowGroup="{
        field: 'branch.branch_name_en'
      }"
    >
      <template v-slot="{ record }">
        <td>
          {{ record.year ? record.year.ac_year : '' }}
        </td>
        <td>{{ record.class_name }}</td>
        <td>
          {{ record.grade ? record.grade.grade_name_foreign : '' }}
        </td>
      </template>
    </ts-table>
  </div>
</template>
<script>
export default {
  name: 'currentGrade',
  data() {
    return {
      loading: false,
      resources: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t('homePage.academicYear')
        },
        { name: this.$t('homePage.className') },
        {
          name: this.$t('homePage.gradeName')
        }
      ]
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('home/teacher/fetchCurrentClasses')
        .then(response => {
          this.resources = response.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>
